import variables from '../variables';

const product = variables.productCategoryColor;

export default product;
